<template>
	<div class="cw-about-us">
		关于我们
  	</div>
</template>

<script>

export default {

	data() {
		return {

		}
	},

	computed: {
      
    },

	created() {

	},

	mounted() {

	},

	methods: {

	}
}
</script>

<style lang="scss" scoped>
.cw-about-us {
    padding-top: 104px;
    font-size: 12px;
}
</style>

